<template>
  <div>
    <div class="loginbody">
      <div class="title">用户登录</div>
      <el-input class="ipt" v-model="input1" clearable placeholder="请输入账号"></el-input>
      <el-input class="ipt" v-model="input2" clearable show-password placeholder="请输入密码"></el-input>
      <!-- <el-input class="ipt" v-model="input" placeholder="请输入激活码"></el-input> -->
      <div class="logindiv">
       <el-button class="dl" type="primary">确认</el-button>
       <el-button class="zc" type="primary">注册</el-button>
       <!-- <router-link class="btn-login"  :to="{ name: 'register' }">注册</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {
      input1:"",
      input2:""
    }

  },
  methods: {
      
  }
};
</script>

<style scoped lang="scss">
.loginbody {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .title {
    font-size: 40px;
    margin-top: 40px 
    ;
  }
}
.ipt {
  width: 500px;
  margin: 40px 0 0 0;
}
.logindiv {
  margin-top: 40px;
  margin-bottom: 40px;
  .zc {
    margin-left: 60px;
  }
}
</style>
